<template>

	<div class="select-currency" :title="'Your currency: ' + getCurrencyName()">
		<b-button :variant="getButtonVariant()" :size="size" ref="currencyButton" @click="showCurrencyItems()"><b-badge variant="dark"><span v-html="getCurrencySymbol()"></span></b-badge> {{ displayCurrencyCode() }}</b-button>
		<form-filterlist header="Select Your Currency"  v-bind:item-factory="getCurrencyItems" v-bind:refresh-items="true" v-bind:item-display="displayCurrencyItem" v-bind:item-style="getItemClass" v-bind:item-html="getItemHtml" v-bind:item-selected="selectCurrencyItem" v-bind:hide-on-select="true" ref="currencyItems"></form-filterlist>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

<script>
import FormFilterlist from '@/components/FormFilterlist';

var Cookies = require('browser-cookies');

export default {
  name: '',
  components: {'form-filterlist': FormFilterlist},
  props: {
	  'size': {type: String,  default: function() { return "sm" }},
  },
  data () {
    return {
      loadingSpinner: true,
//      selectedCurrency: null,
      currencyItems: [],
      savedCurrency: null,

    }
  },

  computed: {

		currencyList: function() {

			//return require('@/assets/data/currencylist.json');
			return require('@/assets/data/currencySymbols.json');
		},

		selectedCurrency: function() {
			return this.$root.$store.getters['CCStore/myCurrency'];
		},
  },

  mounted: function () {

//	    if (this.currencyList) {
//	    	this.currencyItems = Object.keys(this.currencyList).sort();
//	    }

		this.$nextTick(function () {
			// Code that will run only after the
			// entire view has been rendered

//			// restore last profit/loss settings
//			var profitAmount = this.rememberData('profitAmount') || 0;
//			this.$set(this.profitLoss, 'profitAmount', profitAmount);


//			this.initializeData();


		});
	},

  methods: {

	  showCurrencyItems() {

		  if (this.$refs.currencyItems) {
			  this.$refs.currencyItems.showItems();
		  }

	  },

	  getButtonVariant() {

		//this.savedCurrency = Cookies.get('cc-mycurrency');

		// If user has selected a currency, it will be stored in a cookie
		if (this.hasSavedCurrency()) {
			return "primary";
		} else {
			return "outline-primary";
		}
	  },

	  getCurrencyItems() {

		  // Store selected currency in a single item hash for convenience in sort comparison
		  var selectedCurrency = {};
		  selectedCurrency[this.selectedCurrency] = true;

		  function sorter(a, b) {

			  if (a.name) {
				  a = a.value;
			  }

			  if (b.name) {
				  b = b.value;
			  }


			  // is either one of the user selected currency?
			  if ((selectedCurrency[a]) || (selectedCurrency[b])) {

				  if ((selectedCurrency[a]) && (!selectedCurrency[b])) {
					  // a is a user exchange so sort it lower
					  return -1;
				  } else if ((!selectedCurrency[a]) && (selectedCurrency[b])) {
					  // a is not a user exchange so sort it higher
					  return 1;
				  } else if ((selectedCurrency[a]) && (selectedCurrency[b])) {
					  // if both are selected, sort alphabetically
					  // Should not happen with selected currency since it is a single value
					  // but we will still cover it for completeness.
					  return a.localeCompare(b);
				  }

			  }
			  // Everything else sort alphabetically
			  else {
				  return a.localeCompare(b);
			  }
		  }

		  var itemList = [];
		  for (var item in this.currencyList) {
//			  itemList.push({"name": this.currencyList[item].Name, "value":item});
			  itemList.push({"name": this.currencyList[item].FullName, "value":item, "htmlCode": this.getHtmlCode(this.currencyList[item]) });
		  }
		  // Apply custom sort
		  itemList.sort(sorter);
		  return itemList;
	  },

	  displayCurrencyItem(item) {
		  return item.name + " (" + item.value + ")";
	  },

	  selectCurrencyItem(item) {
		  //this.selectedCurrency = item.value;
		  this.$root.$store.commit('CCStore/updateMyCurrency', item.value); // save state
		  this.selectedCurrencySymbol = this.getHtmlCode(item.value);
		  this.$forceUpdate(); // force repainting the screen so cookie will be re-evaluated in getButtonVariant()
	  },

	  getCurrencyName() {
		  if ((this.currencyList[this.selectedCurrency]) && (this.currencyList[this.selectedCurrency].FullName)) {
			  return this.currencyList[this.selectedCurrency].FullName;
		  }
	  },

	  getCurrencyCode() {

		  if (this.currencyList[this.selectedCurrency]) {
			  return this.selectedCurrency;
		  }
	  },

	  isSelected(currency) {
		  if (this.selectedCurrency === currency.value) {
			  return true;
		  }

		  return false;
	  },

	  hasSavedCurrency() {

		   // Check for saved currency cookie
		   var currencyCookie = Cookies.get('cc-mycurrency');

		   if ((currencyCookie) && (typeof currencyCookie == 'string')) {
			   return true;
		   }

		   return false;
	  },

	  getSavedCurrency() {

		// Get value from saved currency cookie
		return Cookies.get('cc-mycurrency');

	  },

	  getItemClass(item) {
		  var classValue = "";

		  if ((this.hasSavedCurrency() === true) && (this.isSelected(item) === true )) {
			  classValue = "text-success";
		  }

		  return classValue;
	  },

	  getItemHtml(item) {
		  var returnValue = "";

		  if ((this.hasSavedCurrency() === true) && (this.isSelected(item) === true )) {
			  returnValue = '<i class="fa fa-star favorite" />';
		  }

		  return returnValue;
	  },

	  displayCurrencyCode() {

		if (this.hasSavedCurrency()) {
			return this.getSavedCurrency();
		} else {
			return "Select Currency!";
		}
	  },

	  getCurrencySymbol() {
		  if (this.currencyList[this.selectedCurrency]) {
			  return this.getHtmlCode(this.currencyList[this.selectedCurrency]);
		  }
	  },

	  getHtmlCode(currency) {
		  var htmlCode = "$"; //default to dollar sign
		  var chars;
		  var counter;

		  var currencyRecord;

		  if (typeof currency == "object") {
			  currencyRecord = currency;

		  } else {
			  if (this.currencyList[currency]) {
				  currencyRecord = this.currencyList[currency];
			  }
		  }

		  if ((currencyRecord) && (currencyRecord.UnicodeHex)) {
			  // Some currencies use multiple characters separated by comma
			  chars = currencyRecord.UnicodeDecimal.split(',');
			  htmlCode = "";
			  for (counter = 0; counter < chars.length; counter++ ) {
				  // convert to HTML unicode hex entities
				  htmlCode += "&#"+ chars[counter] + ";";
			  }
		  }

		  return htmlCode;
	  },

//	  initializeData() {
//
//
//
//	  }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/SelectCurrency.vue